import ScrollMenuComponent from './ScrollMenuComponent';

export default ScrollMenuComponent;
